'use strict';

import { module } from '../app';

module.service('ReferencePhysician', [
  'AjaxService', 'authService', 'magViewApi', '$http', '$q',
  function (AjaxService, authService, magViewApi, $http, $q) {
    return {
      get: function (refNum) {
        return AjaxService.get(authService.currentMagViewUrl() + magViewApi + '/referringPhysician/' + refNum);
      },
      loadForAutocomplete: function (query, pageIndex, usedRefPhyKeys, isInitialized) {
        let url = authService.currentMagViewUrl() + magViewApi + '/referringPhysician/loadForAutocomplete';
        const body = {
          Query: query,
          PageIndex: pageIndex,
          RefNumsToExclude: usedRefPhyKeys,
          IsInitialized: isInitialized,
        };
        let canceler = $q.defer();
        let listener = $http.post(url, body, { timeout: canceler.promise });
        listener.canceler = canceler;
        return listener;
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/refPhy.js